import { render, staticRenderFns } from "./MessageNew.vue?vue&type=template&id=02d70de6&scoped=true&"
import script from "./MessageNew.vue?vue&type=script&lang=js&"
export * from "./MessageNew.vue?vue&type=script&lang=js&"
import style0 from "./MessageNew.vue?vue&type=style&index=0&id=02d70de6&scoped=true&lang=scss&"
import style1 from "./MessageNew.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d70de6",
  null
  
)

export default component.exports